<template>
    <footer class="bg-black text-white py-8 text-center">
        <p class="mb-2">
            &copy; {{ new Date().getFullYear() }} AGRIFUTURA SDN. BHD.
        </p>
        <p class="text-sm">
            Empowering agriculture with technology and sustainability.
        </p>
    </footer>
</template>
